import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { GuiaEntrada } from '../types/guiaEntrada.types';

interface GuiaEntradaStore {
  guias: GuiaEntrada[];
  loading: boolean;
  setGuias: (guias: GuiaEntrada[]) => void;
  setLoading: (loading: boolean) => void;
}

export const useGuiaEntradaStore = create<GuiaEntradaStore>()(
  devtools(
    (set) => ({
      guias: [],
      loading: false,
      setGuias: (guias) => set({ guias }),
      setLoading: (loading) => set({ loading }),
    }),
    { name: 'GuiaEntradaStore' }
  )
);
